import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import Logo from "../../assets/img/logo/TGVC-Logo.png";
import footerBG from "../../assets/img/footer/footer-bg-2.jpg";
import "react-toastify/dist/ReactToastify.css";

const Footer = (props) => {
  const { footerLogo, footerClass } = props;

  const [email, setEmail] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();

    const emailRegex = /\S+@\S+\.\S+/;
    if (!email || !emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    try {
      const response = await fetch("https://sheetdb.io/api/v1/pa9fxxsf8sec1", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: { subscriber_email: email } }),
      });

      if (response.ok) {
        toast.success("Thanks for subscribing!");
        setEmail("");
      } else {
        toast.error("Something went wrong. Try again later.");
      }
    } catch (err) {
      toast.error("Connection failed. Please check your internet.");
    }
  };

  return (
    <footer>
      <div
        className={footerClass ? footerClass : "footer__area footer__plr"}
        style={{ backgroundImage: `url(${footerBG})` }}
      >
        <div className="container-fluid">
          <div className="row">
            <div
              className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-1">
                <div className="footer__logo">
                  <Link to="/">
                    <img src={footerLogo ? footerLogo : Logo} alt="" />
                  </Link>
                </div>
                <div className="footer__content">
                  <div className="footer__text">
                    <p>
                      We provide tailored software development, IT consulting &
                      cloud services to help startups and enterprises innovate
                      faster and scale smarter.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/*<div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-2">
                <h4 className="footer__title">
                  <Link to="/service">Service</Link>
                </h4>
                <div className="footer__menu-list">
                  <ul>
                    <li>
                      <a href="#">Web Design</a>
                    </li>
                    <li>
                      <a href="#">Development</a>
                    </li>
                    <li>
                      <a href="#">WordPress</a>
                    </li>
                    <li>
                      <a href="#">Online Marketing</a>
                    </li>
                    <li>
                      <a href="#">Content</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-2 col-lg-6 col-md-6 col-sm-5 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-3">
                <h4 className="footer__title">
                  <a href="#">Quick Link</a>
                </h4>
                <div className="footer__menu-list">
                  <ul>
                    <li>
                      <a href="#">Web Design</a>
                    </li>
                    <li>
                      <a href="#">Development</a>
                    </li>
                    <li>
                      <a href="#">WordPress</a>
                    </li>
                    <li>
                      <a href="#">Online Marketing</a>
                    </li>
                    <li>
                      <a href="#">Content</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>*/}
            <div
              className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-70 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="footer__widget footer-col-4">
                <h4 className="footer__title">Newsletter</h4>
                <div className="footer__content">
                  <p>
                    Get the latest updates and tech insights delivered straight
                    to your inbox.
                  </p>
                </div>
                <div className="footer__input">
                  <form onSubmit={handleSubscribe}>
                    <input
                      type="email"
                      placeholder="Your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <button className="subscribe-btn">Subscribe </button>
                  </form>
                  <ToastContainer position="top-center" autoClose={3000} />
                </div>
                <div className="footer__number-wrapper d-flex align-items-center">
                  <div className="footer__number-icon">
                    <span>
                      <i className="fal fa-phone-alt"></i>
                    </span>
                  </div>
                  <div className="footer__number-info">
                    <span>Have Any Questions?</span>
                    {/*<a href="tel:+91-9096781543">+91-9096781543</a><br />*/}
                    <a href="tel:+91-9500141809">+91 - 9500141809</a>
                  </div>
                </div>

                <div className="footer__social-box mt-4">
                  <span>Social Media:</span>
                  <a href="#">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a href="#">
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright__area copyright__plr black-bg-3">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div
              className="col-md-6 wow animate__slideInUp"
              data-wow-duration="1.1s"
            >
              <div className="copyright__text">
                <span>
                  Copyright © TGVC Technologies 2024, All Right Reserved.
                </span>
              </div>
            </div>
            <div
              className="col-md-6 wow animate__fadeInUp"
              data-wow-duration="1.1s"
            >
              <div className="copyright__item text-start text-md-end">
                <span>
                  <a href="#">Privacy & Policy</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
